// extracted by mini-css-extract-plugin
export default {"container":"upload-btn_container__wt1FJ"};